var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("考勤异常申诉详情")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", [
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("任务编号：" + _vm._s(_vm.detail.jobNo)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("任务名称：" + _vm._s(_vm.detail.jobTitle)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v(
                    "\n            申诉状态：" +
                      _vm._s(
                        _vm.detail.operateStatus == 0
                          ? "待审核"
                          : _vm.detail.operateStatus == 1
                          ? "审核通过"
                          : "审核拒绝"
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v(
                    "\n            打卡时间：" +
                      _vm._s(_vm.detail.startTime) +
                      "至" +
                      _vm._s(_vm.detail.endTime) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v(
                    "\n            打卡状态：" +
                      _vm._s(
                        _vm.detail.signStatus == 0
                          ? "未打卡"
                          : _vm.detail.signStatus == 1
                          ? "正常打卡"
                          : _vm.detail.signStatus == -1
                          ? "迟到打卡"
                          : "早退打卡"
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("申诉人：" + _vm._s(_vm.detail.appealName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("申诉原因：" + _vm._s(_vm.detail.appealReason)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("申诉时间：" + _vm._s(_vm.detail.gmtCreate)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("申诉提交信息："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "flex-wrap": "wrap",
                    },
                  },
                  _vm._l(_vm.detail.fileList, function (item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        item.fileType == 0
                          ? _c("el-image", {
                              staticStyle: {
                                width: "100px",
                                height: "150px",
                                "margin-right": "30px",
                              },
                              attrs: {
                                src: item.url,
                                alt: "",
                                "preview-src-list": [item.url],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.fileType == 1
                          ? _c("audio", {
                              ref: "audioPlayer",
                              refInFor: true,
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                "margin-right": "10px",
                              },
                              attrs: { src: item.url },
                              on: {
                                play: _vm.handlePlay,
                                pause: _vm.handlePause,
                                timeupdate: _vm.updateTime,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              margin: "5px 0 10px",
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.fileName) +
                                "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("处理人：" + _vm._s(_vm.detail.operatorName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v(
                    "\n            处理状态：" +
                      _vm._s(
                        _vm.detail.operateStatus == 0
                          ? "待审核"
                          : _vm.detail.operateStatus == 1
                          ? "审核通过"
                          : "审核拒绝"
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("处理信息：" + _vm._s(_vm.detail.rejectReason)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "infoItem" }, [
                  _vm._v("处理时间：" + _vm._s(_vm.detail.operateAt)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticStyle: { margin: "10px 10px" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { "margin-right": "auto", width: "240px" },
                        attrs: { placeholder: "请选择考勤日" },
                        on: { change: _vm.selectTime },
                        model: {
                          value: _vm.workTime,
                          callback: function ($$v) {
                            _vm.workTime = $$v
                          },
                          expression: "workTime",
                        },
                      },
                      _vm._l(_vm.detail.newTime, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.key, value: item.dayNum },
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        staticStyle: { height: "32px", "line-height": "4px" },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.big()
                          },
                        },
                      },
                      [_vm._v("全屏")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticStyle: { width: "400px", height: "400px" },
                  attrs: { id: "map" },
                }),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }